export default {
  title: 'Werkstoffzusammensetzung importieren',
  helpText: 'Fügen Sie den Text einer Werkstoffzusammensetzung in das untenstehende Textfeld ein – z.B. aus einem Datenblatt oder einer Website kopiert. Das Tool erkennt automatisch die Grenzen der enthaltenen Legierungselemente und zeigt diese direkt in der Vorschautabelle an.',
  failure: {
    summary: 'Unvollständige oder nicht eindeutig interpretierbare Werte erkannt',
    details: 'Einige Legierungselemente wurden erkannt, aber die zugehörigen Werte fehlen oder konnten nicht eindeutig interpretiert werden. Bitte überprüfe die folgende Liste und ergänze die betroffenen Angaben manuell.',
    emptyValue: 'Es wurden keine Werte für das Legierungselment gefunden',
    addToComposition: 'Element hinzufügen',
    removeFromComposition: 'Element entfernen',
  },
};
